var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Back",
    clipPath: "url(#clip0_4831_14638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.68442 9.68039C4.59109 9.68039 4.49924 9.64483 4.42813 9.57372L0.130348 5.27594C-0.0118739 5.13372 -0.0118739 4.90409 0.130348 4.76335L4.42813 0.464089C4.57035 0.321866 4.79998 0.321866 4.94072 0.464089C5.08294 0.606311 5.08294 0.83594 4.94072 0.976681L0.899237 5.01964L4.94072 9.06113C5.08294 9.20335 5.08294 9.43298 4.94072 9.57372C4.86961 9.64483 4.77776 9.68039 4.68442 9.68039Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.4829 15.641H3.25917C3.05917 15.641 2.89621 15.478 2.89621 15.278C2.89621 15.078 3.05917 14.915 3.25917 14.915H10.4829C13.111 14.915 15.2503 12.7758 15.2503 10.1476C15.2503 7.51948 13.111 5.38022 10.4829 5.38022H1.19695C0.996947 5.38022 0.833984 5.21726 0.833984 5.01726C0.833984 4.81726 0.996947 4.6543 1.19695 4.6543H10.4829C11.2236 4.6543 11.9436 4.79948 12.6207 5.08541C13.2755 5.36244 13.8621 5.758 14.3673 6.2617C14.8725 6.76541 15.2681 7.35356 15.5451 8.00837C15.831 8.68541 15.9777 9.40541 15.9777 10.1476C15.9777 10.8884 15.8325 11.6084 15.5466 12.2854C15.2695 12.9402 14.874 13.5269 14.3703 14.0321C13.8666 14.5373 13.2784 14.9328 12.6236 15.2099C11.9436 15.4958 11.2251 15.641 10.4829 15.641Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4831_14638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.0cf3b89627e8d6883e39d7a7b6114133.svg";
export { ForwardRef as ReactComponent };